import React from 'react';
import type { ConsensusRevisionWidgetConfig } from './types';
import { definition } from './index';

interface Props {
  config: Partial<ConsensusRevisionWidgetConfig>;
  onChange: (config: ConsensusRevisionWidgetConfig) => void;
}

const ConsensusRevisionWidgetBuilder: React.FC<Props> = () => (
  <div className="space-y-4">
    <div className="bg-warning-50 border border-warning-200 rounded-lg p-4 text-sm text-warning-800">
      <strong>{definition.meta.label}</strong>
      <p className="mt-1">{definition.meta.description}</p>
    </div>
    <div className="border rounded-lg p-4 bg-primary-50 border-primary-200">
      <h4 className="font-medium text-primary-800 mb-2">How it works</h4>
      <ul className="text-sm text-primary-700 space-y-1 ml-5 list-disc">
        <li>Consensus estimate for the KPI (InSync consensus revisions), left axis</li>
        <li>The asset&apos;s stock price (FMP), right axis</li>
        <li>Correlation between the two series over the period</li>
        <li>Aligned by date so revisions and price move on the same timeline</li>
      </ul>
    </div>
  </div>
);

export default ConsensusRevisionWidgetBuilder;
